interface NoCreditsModalProps {
  title?: string;
  copy?: string;
  onClose: () => void;
  onGetCredits: () => void;
}

const NoCreditsModal = ({
  title = 'Not enough credits',
  copy = "You don't have enough credits to build this page. Top up your account to continue.",
  onClose,
  onGetCredits,
}: NoCreditsModalProps) => (
  <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/40 p-4">
    <div className="w-full max-w-[360px] rounded-[16px] bg-white p-[28px_24px_24px] shadow-[0_20px_60px_rgba(0,0,0,0.18)]">
      <div className="mb-[6px] flex items-center gap-[10px]">
        <div className="flex h-[36px] w-[36px] shrink-0 items-center justify-center rounded-full bg-[rgba(217,119,6,0.12)]">
          <i className="fa-solid fa-coins text-[15px] text-[#D97706]" />
        </div>
        <div className="text-[16px] font-[800] tracking-[-0.3px] text-[#0D0D1A]">{title}</div>
      </div>
      <p className="mb-[22px] text-[13px] leading-[1.6] text-[#0D0D1A]/56">{copy}</p>
      <div className="flex gap-[10px]">
        <button
          type="button"
          onClick={onClose}
          className="flex-1 cursor-pointer rounded-[9px] border border-black/10 bg-white py-[10px] text-[13px] font-[700] text-[#0D0D1A]/56 transition-all hover:bg-black/5"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={onGetCredits}
          className="flex-1 cursor-pointer rounded-[9px] border-none bg-[linear-gradient(135deg,#6D28D9,#0891B2)] py-[10px] text-[13px] font-[700] text-white transition-all hover:opacity-90"
        >
          Get Credits
        </button>
      </div>
    </div>
  </div>
);

export default NoCreditsModal;
